﻿import { Box, Grid } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TimeHelper from '../../../../utils/time';
import CustomerQuery from '../../../../services/query/customer/CustomerQuery.services';
import { CAH } from './accountHistory.classes';
interface IProps {
    datas?: any;
    refresh?: any;
}

export const AccountHistory: FC<IProps> = ({ datas }) => {
    const { t } = useTranslation();
    const [customerAccountHistory, setCustomerAccountHistory] = useState<any>([]);
    const [pageSize, setPageSize] = React.useState(5);

    const columns: ExtendedGridColDef[] = [
        { field: 'date', headerName: t('general.date'), flex: 1 },
        { field: 'source', headerName: t('customerInformation.source'), flex: 1 },
        { field: 'info', headerName: t('general.info'), flex: 1 },
        { field: 'description', headerName: t('general.description'), flex: 1 },
    ];

    const GetCustomerAccountHistoryList = async () => {
        let request = {
            customerId: datas.customer.customerId,
            email: datas.customer.email,
            phoneNumber: datas.customer.phoneNumber,
        };
        CustomerQuery.GetCustomerAccountHistory(request)
            .then((res: any) => {
                if (res.customerLogs) {
                    let parseData = res.customerLogs.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.date) || '-',
                            source: item.platform || '-',
                            info: item.logType || '-',
                            description: item.description || '',
                        };
                    });
                    setCustomerAccountHistory(parseData);
                }
            })
            .finally(() => {});
    };

    useEffect(() => {
        GetCustomerAccountHistoryList();
    }, []);
    return (
        <Grid container className={CAH.page}>
            <Grid
                className={CAH.gridOuter}
                sx={{ padding: '8px' }}
                container
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    className={CAH.gridInner}
                    sx={{ marginLeft: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Box className={CAH.datagrid}>
                        <SCUICustomDataGrid
                            randomId
                            rows={customerAccountHistory}
                            columns={columns}
                            pageSize={pageSize}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

